import { useCallback } from "react";

import { ConfirmModalProps, useModal } from "@/context/ModalProvider";

export const useConfirmationModal = () => {
  const { showModal } = useModal();

  const showConfirmation = useCallback(
    ({
      title,
      message,
      confirmLabel,
      cancelLabel,
      onConfirm,
      onCancel
    }: ConfirmModalProps) => {
      showModal("confirm", {
        title,
        message,
        cancelLabel: cancelLabel || "Cancel",
        confirmLabel,
        onConfirm,
        onCancel
      });
    },
    [showModal]
  );

  return { showConfirmation };
};
